//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            index: 0,
            slides: [
                {
                    textLeft: this.$lang.get('w4d3.game1.thrill', {br: '\n'}),
                    textRight: this.$lang.get('w4d3.game1.avoid', {br: '\n'})
                },
                {
                    textLeft: this.$lang.get('w4d3.game1.stop', {br: '\n'}),
                    textRight: this.$lang.get('w4d3.game1.works', {br: '\n'})
                },
                {
                    textLeft: this.$lang.get('w4d3.game1.criticism', {br: '\n'}),
                    textRight: this.$lang.get('w4d3.game1.criticised', {br: '\n'})
                },
                {
                    textLeft: this.$lang.get('w4d3.game1.others', {br: '\n'}),
                    textRight: this.$lang.get('w4d3.game1.pressure', {br: '\n'})
                },
                {
                    textLeft: this.$lang.get('w4d3.game1.training', {br: '\n'}),
                    textRight: this.$lang.get('w4d3.game1.waste', {br: '\n'})
                }
            ]
        };
    },

    computed: {
        result () {
            return this.$game.getMediaResult(this.slides.length);
        }
    },

    methods: {
        nextSlide () {
            this.index++;

            if (this.index === this.slides.length - 1 && !this.showNext) {
                this.showNext = true;
            }
        },
        prevSlide () {
            this.index--;
        }
    }
};
